import { useTranslation } from '@frontend/i18n';
import { ConfirmationModal, ModalControlModalProps } from '@frontend/design-system';
import { ScheduleRequestsTrackingIds } from '../../trackingIds';
import { BackendError, BackendErrorDetails } from './BackendErrorDetails';

type ScheduleRequestNoWritebacksErrorProps = {
  modalProps: ModalControlModalProps;
  onConfirm: (override?: boolean) => void;
  backendError?: BackendError;
};

export const ScheduleRequestNoWritebacksErrorModal = ({
  modalProps,
  onConfirm,
  backendError,
}: ScheduleRequestNoWritebacksErrorProps) => {
  const { t } = useTranslation('scheduleCalendarRequest');
  return (
    <ConfirmationModal
      {...modalProps}
      title={t('Attention')}
      message={t(
        'We failed to confirm this appointment. Would you like to approve this request anyway? If so, please add this to your schedule manually.'
      )}
      onConfirm={onConfirm}
      cancelLabel={t('Return to request')}
      confirmLabel={t('Approve anyway')}
      cancelTrackingId={ScheduleRequestsTrackingIds.noWritebacksRequestErrorConfirmationModalCancelBtn}
      confirmTrackingId={ScheduleRequestsTrackingIds.noWritebacksRequestErrorConfirmationModalConfirmBtn}
    >
      {backendError && <BackendErrorDetails backendError={backendError} />}
    </ConfirmationModal>
  );
};
